import React from 'react';

import { Flex, Text } from '@revenuemarket/cds';
import { Convert } from '@revenuemarket/react';
import { Alert, Card, List } from 'antd';
import dayjs from 'dayjs';
import { ExternalIdPasswordCredential, ExternalCredentialStatus } from '~apis/external-credential';
import { PurchasedCardSalesScrapingStatus } from '~apis/scrape';
import { getAnalyzeStatusTag } from '~components/ScrapeStatus/ListForHometax';

interface ListForCrefiaProps {
  credential: ExternalIdPasswordCredential;
  purchasedCardSalesList: PurchasedCardSalesScrapingStatus[];
}

const ListForCrefia: React.FC<ListForCrefiaProps> = ({ credential, purchasedCardSalesList }) => {
  const isDisconnected = credential.status === ExternalCredentialStatus.DISCONNECTED;

  return (
    <Card title="여신금융협회" bordered={false}>
      <Flex direction="column" gap={isDisconnected ? 12 : 0}>
        {isDisconnected && (
          <Alert
            message="여신금융협회에 로그인할 수 없습니다"
            description="여신금융협회 계정 연결이 끊어졌습니다. 계정 정보를 다시 확인해주세요."
            type="error"
            showIcon
            banner
          />
        )}

        <List
          itemLayout="horizontal"
          dataSource={purchasedCardSalesList.slice(0, 1).map((item, index) => ({
            title: '카드 매출',
            status: item.status,
            scrapedAt: item.scrapedAt,
            key: `scraping-${index}`,
          }))}
          rowKey={(item) => item.key}
          renderItem={(item) => (
            <List.Item>
              <Flex justify="space-between" align="center" style={{ width: '100%' }}>
                <Flex align="center" gap={12}>
                  <Text>{item.title}</Text>
                </Flex>
                <Flex gap={12} align="center">
                  <Convert
                    value={item.scrapedAt}
                    expression={(scrapedAt) => (
                      <Text>{dayjs(scrapedAt).format('YYYY-MM-DD HH:mm:ss')}</Text>
                    )}
                  />
                  {getAnalyzeStatusTag(item.status)}
                </Flex>
              </Flex>
            </List.Item>
          )}
        />
      </Flex>
    </Card>
  );
};

export default ListForCrefia;
